/* eslint-disable */
// https://dev2.bhsn.it/api/aireview/swagger-ui/index.html
import type { AxiosPromise, AxiosInstance } from 'axios';
import { toAxiosOptions, mergeObjects } from '@allibee/utils';

let axiosInstance: AxiosInstance;
let baseURL: string;

const serviceRoute = 'aireview';
export function setupServiceInstance(callback: (serviceRoute: string) => { baseURL: string; instance: AxiosInstance }) {
    const result = callback(serviceRoute);
    axiosInstance = result.instance;
    baseURL = result.baseURL;
}

export function getBaseURL() {
    return baseURL;
}

/**
 * Edit Clause v3
 * @returns AireviewResponseEditClauseDto OK
 * @throws ApiError
 */
export function postEditClauseV3(
    {
        requestBody,
    }: {
        requestBody: AireviewEditClauseFormV3;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponseEditClauseDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/edit-clause/v3',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Review Chat v3. SSE(Server-Sent Events)
 * @returns AireviewReviewChatDtoV2 결과를 실시간 event-stream으로 보낸다.
 * @throws ApiError
 */
export function postReviewChatV3(
    {
        requestBody,
    }: {
        requestBody: AireviewReviewChatFormV3;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewReviewChatDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/review-chat/v3',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Review Chat v2. SSE(Server-Sent Events)
 * @returns AireviewReviewChatDtoV2 결과를 실시간 event-stream으로 보낸다.
 * @throws ApiError
 */
export function postReviewChatV2(
    {
        requestBody,
    }: {
        requestBody: AireviewReviewChatForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewReviewChatDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/review-chat/v2',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 쿼리 컨펌 v2
 * @returns AireviewResponseQueryConfirmDto OK
 * @throws ApiError
 */
export function postCheckpointV2(
    {
        requestBody,
    }: {
        requestBody: AireviewQueryConfirmForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponseQueryConfirmDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/review-chat/query-confirm/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Review Chat 질문 예시 목록 조회
 * @returns AireviewResponseListString OK
 * @throws ApiError
 */
export function getReviewChatQuestionExamples(
    {
        contractType,
    }: {
        /**
         * 계약 타입
         */
        contractType: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponseListString> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/review-chat/question-examples/v1',
                query: {
                    contractType: contractType,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Review Clause Analysis SSE(Server-Sent Events) 방식.
 * @returns string 결과를 실시간 event-stream으로 보낸다.
 * @throws ApiError
 */
export function postReviewClauseAnalysisV2(
    {
        requestBody,
    }: {
        requestBody: AireviewReviewClauseAnalysisFormV2;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<Array<string>> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/review-clause-analysis/v2',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Summarize Contract SSE(Server-Sent Events) 방식 v2.
 * @returns string 결과를 실시간 event-stream으로 보낸다.
 * @throws ApiError
 */
export function summarizeContractV2(
    {
        requestBody,
    }: {
        requestBody: AireviewContractSummarizeFormV2;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<Array<string>> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/summarize/contract/v2',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Summarize Contract SSE(Server-Sent Events) 방식.
 * @returns string 결과를 실시간 event-stream으로 보낸다.
 * @throws ApiError
 */
export function summarizeContractV1(
    {
        requestBody,
    }: {
        requestBody: AireviewContractSummarizeForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<Array<string>> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/summarize/contract/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 계약서 파일 리뷰 v2
 * @returns AireviewResponseReviewDto OK
 * @throws ApiError
 */
export function reviewContractFileV2(
    {
        formData,
    }: {
        formData?: {
            form: AireviewFileReviewFormV2;
            /**
             * 계약서 파일
             */
            file: Blob;
        };
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponseReviewDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/review/contract-file/v2',
                formData: formData,
                mediaType: 'multipart/form-data',
            }),
            requestConfig,
        ),
    );
}
/**
 * 계약서 document(json) 리뷰 v5
 * @returns AireviewResponseReviewDtoV3 OK
 * @throws ApiError
 */
export function reviewContractDocumentV5(
    {
        requestBody,
    }: {
        requestBody: AireviewDocumentReviewFormV4;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponseReviewDtoV3> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/review/contract-document/v5',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 계약서 document(json) 리뷰 Cache v3
 * @returns AireviewResponseReviewDtoV3 OK
 * @throws ApiError
 */
export function reviewContractDocumentByCacheV3(
    {
        requestBody,
    }: {
        requestBody: AireviewDocumentReviewCacheFormV2;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponseReviewDtoV3> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/review/contract-document/by-cache/v3',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Review Contract by Playbook SSE(Server-Sent Events) 방식 v2.
 * @returns AireviewReviewContractByPlaybookDto 결과를 실시간 event-stream으로 보낸다.
 * @throws ApiError
 */
export function reviewContractByPlaybookV2(
    {
        requestBody,
    }: {
        requestBody: AireviewReviewContractByPlaybookFormV2;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewReviewContractByPlaybookDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/review/contract-by-playbook/v2',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Review Contract by Playbook SSE(Server-Sent Events) 방식.
 * @returns AireviewReviewContractByPlaybookDto 결과를 실시간 event-stream으로 보낸다.
 * @throws ApiError
 */
export function reviewContractByPlaybookV1(
    {
        requestBody,
    }: {
        requestBody: AireviewReviewContractByPlaybookForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewReviewContractByPlaybookDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/review/contract-by-playbook/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체크포인트 v5 (체크포인트별 결과)
 * @returns AireviewResponseListCheckClauseResultDto OK
 * @throws ApiError
 */
export function postCheckpointV5(
    {
        requestBody,
    }: {
        requestBody: AireviewCheckpointFormV5;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponseListCheckClauseResultDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/checkpoints/v5',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 번역 v2 SSE(Server-Sent Events) 방식.
 * @returns AireviewTranslateContractResponse 결과를 실시간 event-stream으로 보낸다.
 * @throws ApiError
 */
export function postTranslationV2(
    {
        requestBody,
    }: {
        requestBody: AireviewTranslationForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<Array<AireviewTranslateContractResponse>> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/translations/v2',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 번역 SSE(Server-Sent Events) 방식.
 * @returns string 결과를 실시간 event-stream으로 보낸다.
 * @throws ApiError
 */
export function postTranslationV1(
    {
        requestBody,
    }: {
        requestBody: AireviewTranslationForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<Array<string>> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/translations/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 계약서 기본 정보 추출 v3
 * @returns AireviewResponseContractMetadataDtoV2 OK
 * @throws ApiError
 */
export function predictContractV3(
    {
        requestBody,
    }: {
        requestBody: AireviewContractPredictByFileKeyForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponseContractMetadataDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/contract-prediction/v3',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 계약서 당사자 정보 추출
 * @returns AireviewResponseContractPartiesDto OK
 * @throws ApiError
 */
export function extractPartiesV1(
    {
        requestBody,
    }: {
        requestBody: AireviewContractPredictByFileKeyForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponseContractPartiesDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/contract-prediction/parties/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 계약서 가장 적합한 기본 정보 추출 (basic) v1
 * @returns AireviewResponseMostFitContractBasicMetadataDto OK
 * @throws ApiError
 */
export function predictMostFitContractBasic(
    {
        requestBody,
    }: {
        requestBody: AireviewDocument;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponseMostFitContractBasicMetadataDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/contract-prediction/most-fit/basic/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 계약서 언어 추출
 * @returns AireviewResponseContractLanguagesDto OK
 * @throws ApiError
 */
export function predictContractLangugaesV1(
    {
        requestBody,
    }: {
        requestBody: AireviewContractPredictByFileKeyForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponseContractLanguagesDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/contract-prediction/languages/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 계약서 유형 목록
 * @returns AireviewResponseListContractTypeDto OK
 * @throws ApiError
 */
export function contractTypesV2(_?: any, requestConfig?: RequestConfig): AxiosPromise<AireviewResponseListContractTypeDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/contract-types/v2',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 계약서 유형 목록
 * @returns AireviewResponseListContractTypeDto OK
 * @throws ApiError
 */
export function contractTypesV1(_?: any, requestConfig?: RequestConfig): AxiosPromise<AireviewResponseListContractTypeDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/contract-types/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 코드 목록
 * @returns AireviewResponseMapStringListEnumDto OK
 * @throws ApiError
 */
export function codesV2(_?: any, requestConfig?: RequestConfig): AxiosPromise<AireviewResponseMapStringListEnumDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/codes/v2',
            }),
            requestConfig,
        ),
    );
}
/**
 * @returns string OK
 * @throws ApiError
 */
export function hello(_?: any, requestConfig?: RequestConfig): AxiosPromise<string> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/hello',
            }),
            requestConfig,
        ),
    );
}
/**
 * 라벨 체크포인트 목록 V2
 * @returns AireviewResponseListLabelCheckpointDto OK
 * @throws ApiError
 */
export function getLabelCheckpointsV2(
    {
        contractType,
        language,
        labelIds,
        includeClauseExamples,
    }: {
        /**
         * 계약 타입
         */
        contractType: string;
        /**
         * 언어
         */
        language: 'KO' | 'EN' | 'ETC';
        /**
         * 라벨 IDs
         */
        labelIds?: Array<number>;
        /**
         * 예시 조항 포함 여부
         */
        includeClauseExamples?: boolean;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponseListLabelCheckpointDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/label-checkpoints/v2',
                query: {
                    labelIds: labelIds,
                    includeClauseExamples: includeClauseExamples,
                    contractType: contractType,
                    language: language,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 라벨 체크포인트 목록
 * @returns AireviewResponseListLabelCheckpointDto OK
 * @throws ApiError
 */
export function getLabelCheckpoints(
    {
        contractType,
        language,
        labelIds,
        includeClauseExamples,
    }: {
        /**
         * 계약 타입
         */
        contractType: string;
        /**
         * 언어
         */
        language: 'KO' | 'EN' | 'ETC';
        /**
         * 라벨 IDs
         */
        labelIds?: Array<number>;
        /**
         * 예시 조항 포함 여부
         */
        includeClauseExamples?: boolean;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponseListLabelCheckpointDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/label-checkpoints/v1',
                query: {
                    labelIds: labelIds,
                    includeClauseExamples: includeClauseExamples,
                    contractType: contractType,
                    language: language,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 플레이북(체크리스트 정책) 생성 v1
 * @returns AireviewResponseGeneratePlaybookDto OK
 * @throws ApiError
 */
export function generatePlaybookV1(
    {
        requestBody,
    }: {
        requestBody: AireviewGeneratePlaybookForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponseGeneratePlaybookDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/playbooks/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 유사 조항 목록
 * @returns AireviewResponseListString OK
 * @throws ApiError
 */
export function getSimilarClauses(
    {
        requestBody,
    }: {
        requestBody: AireviewSimilarClauseCondition;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponseListString> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/similar-clauses/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 계약서 새 버전 저장하기 v1
 * @returns AireviewResponse OK
 * @throws ApiError
 */
export function saveDocumentV1(
    {
        contractId,
        requestBody,
    }: {
        contractId: number;
        requestBody: AireviewContractDocumentSaveForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/standalone/contracts/{contractId}/document/v1',
                path: {
                    contractId: contractId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 클라우드 보관함 페이징 조회하기 v1
 * @returns AireviewResponsePageCloudContractDto OK
 * @throws ApiError
 */
export function pageCloudContractsV1(
    {
        searchKeyword,
        sortField,
        sortDirection,
        page,
        size = 10,
        sort,
    }: {
        /**
         * 검색 키워드
         */
        searchKeyword?: string;
        /**
         * 정렬 기준
         */
        sortField?: 'CREATED_AT';
        /**
         * 정렬 방향
         */
        sortDirection?: 'ASC' | 'DESC';
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponsePageCloudContractDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standalone/contracts/v1',
                query: {
                    searchKeyword: searchKeyword,
                    sortField: sortField,
                    sortDirection: sortDirection,
                    page: page,
                    size: size,
                    sort: sort,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 계약서 생성하기 v1
 * @returns AireviewResponseContractCreatedDto OK
 * @throws ApiError
 */
export function createContractV1(
    {
        requestBody,
    }: {
        requestBody: AireviewContractCreateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponseContractCreatedDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/standalone/contracts/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 계약서 문서 미리보기 (file to doumnet)
 * @returns AireviewResponseDocument OK
 * @throws ApiError
 */
export function getDocumentByFile(
    {
        fileKey,
        language,
    }: {
        /**
         * 계약서 파일 key
         */
        fileKey: string;
        /**
         * 계약서 언어(ISO Code: ko, en, etc)
         */
        language?: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponseDocument> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standalone/documents/by-file/v1',
                query: {
                    language: language,
                    fileKey: fileKey,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 계약서 조회하기 v1
 * @returns AireviewResponseStandaloneContractDto OK
 * @throws ApiError
 */
export function getContractV1(
    {
        contractId,
    }: {
        contractId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponseStandaloneContractDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standalone/contracts/{contractId}/v1',
                path: {
                    contractId: contractId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 계약서 파일(docx) 다운로드하기 v1
 * @returns any OK
 * @throws ApiError
 */
export function downloadContractV1(
    {
        contractId,
    }: {
        contractId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<any> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standalone/contracts/{contractId}/download/v1',
                path: {
                    contractId: contractId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Workspace OOD Control Config 업데이트
 * @returns AireviewResponse OK
 * @throws ApiError
 */
export function putWorkspaceOodConfigs(
    {
        requestBody,
    }: {
        requestBody: AireviewWorkspaceOodConfigUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/super-admin/workspace-ood-configs/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Workspace 내 AI Provider Config 목록
 * @returns AireviewResponseListWorkspaceAiServiceConfigDto OK
 * @throws ApiError
 */
export function getWorkspaceAiServiceConfigs(
    {
        workspaceId,
    }: {
        /**
         * 워크스페이스 ID
         */
        workspaceId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponseListWorkspaceAiServiceConfigDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/workspace-ai-service-configs/v1',
                query: {
                    workspaceId: workspaceId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Workspace 내 AI Provider Config 업데이트
 * @returns AireviewResponse OK
 * @throws ApiError
 */
export function putWorkspaceAiServiceConfigs(
    {
        requestBody,
    }: {
        requestBody: AireviewWorkspaceAiServiceConfigUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/super-admin/workspace-ai-service-configs/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 조항 예시 엑셀 업로드
 * @returns AireviewResponse OK
 * @throws ApiError
 */
export function updateClauseExamplesByExcel(
    {
        tenantId,
        workspaceId,
        formData,
    }: {
        /**
         * 테넌트 ID
         */
        tenantId: number;
        /**
         * 워크스페이스 ID
         */
        workspaceId: number;
        formData?: {
            file: Blob;
        };
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/super-admin/clause-examples/excel/v1',
                query: {
                    tenantId: tenantId,
                    workspaceId: workspaceId,
                },
                formData: formData,
                mediaType: 'multipart/form-data',
            }),
            requestConfig,
        ),
    );
}
/**
 * 워크스페이스별 라벨 체크포인트 엑셀 업로드
 * @returns AireviewResponse OK
 * @throws ApiError
 */
export function uploadLabelCheckpointsExcel(
    {
        tenantId,
        workspaceId,
        formData,
    }: {
        /**
         * 테넌트 ID
         */
        tenantId: number;
        /**
         * 워크스페이스 ID
         */
        workspaceId: number;
        formData?: {
            file: Blob;
        };
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/super-admin/label-checkpoints/excel/v1',
                query: {
                    tenantId: tenantId,
                    workspaceId: workspaceId,
                },
                formData: formData,
                mediaType: 'multipart/form-data',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * Workspace OOD Control Config 조회
 * @returns AireviewResponseWorkspaceOodConfigDto OK
 * @throws ApiError
 */
export function getWorkspaceOodConfigsBySuperAdmin(
    {
        workspaceId,
    }: {
        workspaceId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponseWorkspaceOodConfigDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/workspace-ood-configs/workspace/{workspaceId}/v1',
                path: {
                    workspaceId: workspaceId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Workspace Ai Config 조회
 * @returns AireviewResponseWorkspaceAiConfigDto OK
 * @throws ApiError
 */
export function getWorkspaceAiConfigBySuperAdmin(
    {
        workspaceId,
    }: {
        workspaceId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponseWorkspaceAiConfigDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/workspace-ai-configs/workspace/{workspaceId}/v1',
                path: {
                    workspaceId: workspaceId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 워크스페이스별 라벨 체크포인트 엑셀 다운로드
 * @returns any OK
 * @throws ApiError
 */
export function downloadLabelCheckpointsExcel(
    {
        workspaceId,
    }: {
        workspaceId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<any> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/label-checkpoints/workspace/{workspaceId}/excel/v1',
                path: {
                    workspaceId: workspaceId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 조항 예시 엑셀 다운로드
 * @returns any OK
 * @throws ApiError
 */
export function downloadClauseExampleExcel(
    {
        workspaceId,
    }: {
        workspaceId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<any> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/clause-examples/workspace/{workspaceId}/excel/v1',
                path: {
                    workspaceId: workspaceId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 사용자의 OOD Config 조회 v1
 * @returns AireviewResponseUserOodConfigDto OK
 * @throws ApiError
 */
export function getUserOodConfigs(_?: any, requestConfig?: RequestConfig): AxiosPromise<AireviewResponseUserOodConfigDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/user-ood-configs/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 사용자 OOD Config 수정 v1
 * @returns AireviewResponse OK
 * @throws ApiError
 */
export function putUserOodConfigs(
    {
        requestBody,
    }: {
        requestBody: AireviewUserOodConfigUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AireviewResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/user-ood-configs/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 사용자 워크스페이스의 OOD Config 조회 v1
 * @returns AireviewResponseWorkspaceOodConfigDto OK
 * @throws ApiError
 */
export function getWorkspaceOodConfigs(_?: any, requestConfig?: RequestConfig): AxiosPromise<AireviewResponseWorkspaceOodConfigDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/workspace-ood-configs/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 사용자의 워크스페이스 내 Contract Type 목록 v5
 * @returns AireviewResponseListWorkspaceContractTypeDtoV3 OK
 * @throws ApiError
 */
export function getWorkspaceContractTypesV5(_?: any, requestConfig?: RequestConfig): AxiosPromise<AireviewResponseListWorkspaceContractTypeDtoV3> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/workspace-contract-types/v5',
            }),
            requestConfig,
        ),
    );
}
/**
 * 사용자의 워크스페이스 내 Contract Type 목록 v4
 * @returns AireviewResponseListWorkspaceContractTypeDto OK
 * @throws ApiError
 */
export function getWorkspaceContractTypesV4(_?: any, requestConfig?: RequestConfig): AxiosPromise<AireviewResponseListWorkspaceContractTypeDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/workspace-contract-types/v4',
            }),
            requestConfig,
        ),
    );
}
/**
 * 사용자의 워크스페이스 내 Ai Service Config 조회
 * @returns AireviewResponseListWorkspaceAiServiceConfigDto OK
 * @throws ApiError
 */
export function getWorkspaceAiConfig(_?: any, requestConfig?: RequestConfig): AxiosPromise<AireviewResponseListWorkspaceAiServiceConfigDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/workspace-ai-service-configs/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 사용자 워크스페이스의 Ai Config 조회 v1
 * @returns AireviewResponseWorkspaceAiConfigDto OK
 * @throws ApiError
 */
export function getWorkspaceAiConfig_8YLO(_?: any, requestConfig?: RequestConfig): AxiosPromise<AireviewResponseWorkspaceAiConfigDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/workspace-ai-configs/v1',
            }),
            requestConfig,
        ),
    );
}
